import React from 'react';
import PropTypes from 'prop-types';
import './CheckboxInput.scss';

const CheckboxInput = ({
  name, label, id, className, value, onChange, iconPosition, checked, testId,
}) => {
  const checkedProps = typeof checked === 'boolean' ? { checked } : {};

  return (
    <label className={`checkboxInput ${className} ${iconPosition === 'right' ? 'checkboxInput--iconRight' : ''}`} htmlFor={id}>
      <input
        type="checkbox"
        id={id}
        className="checkboxInput__checkbox"
        name={name}
        value={value}
        onChange={onChange}
        {...checkedProps}
        data-testid={testId}
      />
      <span className="checkboxInput__checkbox--custom" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          pointerEvents="none"
          width="8"
          height="8"
          className="checkboxInput__tick-icon"
          viewBox="0 0 8 8"
          fill="none"
        >
          <path
            d="M1.5 4.1L3.1 5.7L6.5 2.3"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <span className="checkboxInput__label">{label}</span>
    </label>
  );
};

CheckboxInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  checked: PropTypes.bool,
  testId: PropTypes.string,
};

CheckboxInput.defaultProps = {
  name: 'checkbox',
  label: null,
  id: null,
  className: '',
  value: '',
  iconPosition: 'left',
  checked: undefined,
  testId: null,
};

export default CheckboxInput;
